import { render, staticRenderFns } from "./ShippedOrders.vue?vue&type=template&id=36ad201c"
import script from "./ShippedOrders.vue?vue&type=script&lang=js"
export * from "./ShippedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports